import { render, staticRenderFns } from "./CollectedPackages.vue?vue&type=template&id=26c67a60"
import script from "./CollectedPackages.vue?vue&type=script&lang=js"
export * from "./CollectedPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports